/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use the homepage download section as a starting point, then check the official release page for the filename and version. Keep the installer version in your notes. If you later report an issue or compare a desktop behavior with this site’s online editor, knowing whether both are v0.7.0 avoids confusing an upgrade with a platform difference. Downloading a newer release does not update an already open browser session.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以从首页下载区开始，再到官方发布页核对文件名与版本，并记录安装包版本。之后报告问题或比较桌面与在线行为时，确认两者是否同为 v0.7.0，可以避免把版本更新误认为平台差异。下载较新版本，也不会更新已经打开的浏览器会话。`)
};

/**
* | output |
* | --- |
* | "Use the homepage download section as a starting point, then check the official release page for the filename and version. Keep the installer version in your ..." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_6_Paragraphs_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_6_paragraphs_1 as "gc.search_guides.what_is_gridcraft.sections.6.paragraphs.1" }